import actionTypes from '../actionTypes';

const dialogInitial = { visible: false, view: ''};
export const dialog = (state = dialogInitial, action) => {
    switch (action.type) {
        case actionTypes.OPEN_DIALOG:
            return { visible: true, view: action.view, params: action.params };
        case actionTypes.CLOSE_DIALOG:
        case actionTypes.CREATE_CLUB_SUCCESS:
        case actionTypes.DISBAND_CLUB_SUCCESS:
        case actionTypes.JOIN_CLUB_SUCCESS:
        case actionTypes.SEND_MESSAGE_SUCCESS:
        case actionTypes.SET_PROFILE_AVATAR_SUCCESS:
        case actionTypes.CHANGE_CLUB_SUCCESS:
        case actionTypes.EXCHANGE_SAPPHIRES_SUCCESS:
        case actionTypes.REMOVE_MEMBER_SUCCESS:
        case actionTypes.CHANGE_PASSWORD_SUCCESS:
        case actionTypes.UPDATE_LEVEL_SUCCESS:
        case actionTypes.CREATE_UNION_SUCCESS:
        case actionTypes.JOIN_UNION_SUCCESS:
        case actionTypes.CHANGE_MEMBER_ROLE_SUCCESS:
        case actionTypes.DISBAND_UNION_SUCCESS:
        case actionTypes.QUIT_MEMBER_CLUB_SUCCESS:
        case actionTypes.QUIT_UNION_CLUB_SUCCESS:
        case actionTypes.CHANGE_MEMBER_ROLE_FAILURE:
            return dialogInitial;
        default:
            return state
    }
};
